var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.running)?_c('ActionsLoader'):_c(_vm.selectedComp,{tag:"component",attrs:{"action":_vm.action,"item":_vm.item,"scopeName":_vm.scopeName}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }